import Home from '@/components/home'
import Customer from '@/components/customer'
import Service from '@/components/service'
import School from '@/components/school'
import Yizhijia from '@/components/yizhijia'
import Intro from '@/components/aboutUs_intro'
import News from '@/components/aboutUs_news'
import Jiaopei from '@/components/product_jiaopei'
import Zhaosheng from '@/components/product_zhaosheng'
import Pay from '@/components/product_pay'
import Face from '@/components/product_face'
import Hservice from '@/components/product_hservice'
import Online from '@/components/product_online'
import Onwork from '@/components/product_onwork'
import newsDetail from '@/components/newDetail'
import Joinus from '@/components/joinUs'
import Test1 from '@/components/test1'
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    },
    {
      path: '/school',
      name: 'school',
      component: School
    },
    {
      path: '/yizhijia',
      name: 'yizhijia',
      component: Yizhijia
    },
    {
      path: '/aboutUs_intro',
      name: 'intro',
      component: Intro
    },
    {
      path: '/aboutUs_news',
      name: 'news',
      component: News
    },
    {
      path: '/product_jiaopei',
      name: 'jiaopei',
      component: Jiaopei
    },
    {
      path: '/product_zhaosheng',
      name: 'zhaosheng',
      component: Zhaosheng
    },
    {
      path: '/product_pay',
      name: 'pay',
      component: Pay
    },
    {
      path: '/product_hservice',
      name: 'hservice',
      component: Hservice
    },
    {
      path: '/product_face',
      name: 'face',
      component: Face
    },
    {
      path: '/product_online',
      name: 'online',
      component: Online
    },
    {
      path: '/product_onwork',
      name: 'onwork',
      component: Onwork
    },
    {
      path: '/newsDetail',
      name: 'detail',
      component: newsDetail
    },
    {
      path: '/joinUs',
      name: 'join',
      component: Joinus
    },
    {
      path: '/test1',
      name: 'test1',
      component: Test1
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js